var $ = jQuery;

$(function () {
    var $bc = $(".mcl-block-card");
    $bc.slice(0, 6).removeClass('hidden');
    var $total = $bc.length;
    var $curr = 6;
    if ($curr >= $total) {
        $('.mcl-load-more button').addClass('hidden');
    }
    $(".mcl-show-more").on('click', function (e) {
        e.preventDefault();
        $(".mcl-block-card.hidden").slice(0, 6).removeClass('hidden').slideDown();
        if ($(".mcl-block-card.hidden").length == 0) {
            $("#load").fadeOut('slow');
        }

        // $('html,body').animate({
        //     scrollTop: $(this).offset().top - 300
        // }, 1500);
        $curr += 6;
        if ($curr >= $total) {
            $('.mcl-load-more button').addClass('hidden');
        }
    });
});



// WEBPACK FOOTER //
// ./src/components/templates/teachings/teachings.js